import React from "react";
import { Path } from "../Path";
import { AppWithSideMenu } from "../core/AppWithSideMenu";
import { makeBreadcrumbs3 } from "../core/Breadcrumbs";
import { ListAndDetail } from "./ListAndDetail";
import { AppLink } from "../styleguide/AppLink";
import { useAllConventions, useUserSessions } from "@seabrookstudios/pitch2table";
import Skeleton from "@mui/material/Skeleton";
import { SessionListAndDetail } from "./SessionListAndDetail";

export const routes = [
  {
    path: Path.events().none().pathname,
    element: (
      <AppWithSideMenu>
        <ListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs3([
        () => (
          <AppLink key="events" to={Path.events().none()}>
            Calendar
          </AppLink>
        ),
      ]),
      prefer: "left",
    },
  },
  {
    path: Path.events().event(":conventionId").pathname,
    element: (
      <AppWithSideMenu>
        <ListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs3([
        () => (
          <AppLink key="events" to={Path.events().none()}>
            Calendar
          </AppLink>
        ),
        ({ conventionId }) => {
          const { data: conventions = [] } = useAllConventions();
          const convention = conventions.find((c) => c.id === conventionId);

          return (
            <AppLink key="event" to={Path.events().event(conventionId)}>
              {convention ? convention.name : <Skeleton />}
            </AppLink>
          );
        },
      ]),
      prefer: "right",
    },
  },
  {
    path: Path.session(":sessionId").pathname,
    element: (
      <AppWithSideMenu>
        <SessionListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs3([
        () => (
          <AppLink key="events" to={Path.events().none()}>
            Calendar
          </AppLink>
        ),
        ({ sessionId }) => {
          const { data: sessions = [] } = useUserSessions();
          const session = sessions.find((s) => s.id === sessionId);

          return (
            <AppLink key="event" to={Path.session(sessionId)}>
              {session ? session.type === "Pitching" ? "Pitch Meeting" : "Play Testing Session" : <Skeleton />}
            </AppLink>
          );
        },
      ]),
      prefer: "right",
    },
  },
];
